import axios from "axios"
import router from '../router'

// // axios 配置
// const Axios=axios.create({
//   baseURL: '/',// 是用于请求的服务器 URL 这是调用数据接口,公共接口url+调用接口名
//   timeout: 5000, // 请求超时时间 如果请求花费了超过 `timeout` 的时间，请求将被中断
//   headers: { // 自定义请求头
//     // 'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
//     'Content-type': 'application/json; charset=UTF-8'
//   }
// })
axios.defaults.baseURL='http://zhongchy.zcip.vip'
axios.defaults.timeout=20000

///request拦截器
axios.interceptors.request.use(req => {
  // 上线环境 添加基准路径
  if (process.env.NODE_ENV == 'production') {
    req.url = process.env.BASE_URL + req.url
  }
  return req;
}, error => {
  return Promise.reject(error);
})


function get(url, params) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: url,
            params: params,
        }).then(res => {
            resolve(res.data)

        }).catch(err => {
            reject(err.data)
        })
    })
}

function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        })
    })
}
//非json格式的post请求
function postrest(url, params) {
    return new Promise((resolve, reject) => {

        axios.post(url, params).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        })
    })
}


export default {
    get,
    post,
    postrest
}
